// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 524) return "app-v2-9e17a9e9.css";
	// return url for filenames based on template
	return "" + chunkId + "-v2-" + {"531":"846a8e63","778":"819dcfde","789":"846a8e63"}[chunkId] + ".chunk.css";
};